<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 100%;margin: 0 20px">
      <div style="height: 50px;padding-top: 20px">
        <el-button type="primary" plain icon="el-icon-plus" @click="addBtn()">新增</el-button>
<!--        <el-input prefix-icon="el-icon-search" placeholder="输入编码" style="width: 230px"></el-input>-->
<!--        <el-input prefix-icon="el-icon-search" placeholder="输入名称" style="width: 230px"></el-input>-->
<!--        <el-date-picker v-fixZoom style="width: 250px" v-model="dateVal" type="daterange" range-separator="至"-->
<!--          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">-->
<!--        </el-date-picker>-->
        <el-select v-fixZoom multiple v-model="goodstag" placeholder="请选择类型" style="width: 230px;color: white">
          <el-option v-for="item in goodstags" :key="item.id"
            :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-button type="success" @click="queryTable">查询</el-button>
      </div>
      <div style="max-height: calc(100% - 120px);overflow-y: auto">
        <el-table :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="goods_code"
            label="物资编码"
            min-width="160"
            align="center">
          </el-table-column>
          <el-table-column
            prop="goods_name"
            label="物资名称"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            label="物资类型"
            min-width="90"
            align="center">
            <template slot-scope="scope">
              <span>{{ getTagShow(scope.row.goods_tag) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="goods_location"
            label="物资位置"
            min-width="100"
            align="center">
          </el-table-column>
          <el-table-column
            prop="goods_price"
            label="价格"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="goods_count"
            label="数量"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="goods_specifications"
            label="规格"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="goods_batch_number"
            label="批次"
            min-width="70"
            align="center">
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="goods_valid"-->
<!--            label="有效期"-->
<!--            min-width="100"-->
<!--            align="center">-->
<!--          </el-table-column>-->
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editBtn(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delBtn(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
        <div id="table">
          <el-table :data="excelData" style="width: 100%" border>
            <el-table-column
              v-for="(value, key, index) in tableHead"
              :key="index"
              :prop="key"
              :label="key"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-goods :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-goods>
    </el-dialog>
  </div>
</template>

<script>
import addEditGoods from './components/addEditGoods'
import {querygoodsentity, deletegoodsentity} from '../../api/yanglaoyuan'
import XLSX from 'xlsx'
export default {
  name: 'goodsMaterials',
  components: {addEditGoods},
  data () {
    return {
      tableHead: [],
      excelData: [],
      workbook: '',
      excelURL: 'static/excel/202309.xls', // 文件地址，看你对应怎末获取、赋值
      entityId: 0,
      goodstag: [1, 2],
      goodstags: [{id: 1, name: '固定资产'}, {id: 2, name: '生活物资'}],
      dateVal: '',
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      addEditObj: {
        isAdd: true,
        row: ''
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.queryDataTable()
  },
  mounted () {
    // this.readWorkbookFromRemoteFile()
  },
  methods: {
    // 在线查看excel文件
    readWorkbookFromRemoteFile: function (url) {
      var xhr = new XMLHttpRequest()
      xhr.open('get', this.excelURL, true)
      xhr.responseType = 'arraybuffer'
      let _this = this
      xhr.onload = function (e) {
        if (xhr.status === 200) {
          var data = new Uint8Array(xhr.response)
          var workbook = XLSX.read(data, { type: 'array' })
          console.log('workbook', workbook)
          var sheetNames = workbook.SheetNames // 工作表名称集合
          _this.workbook = workbook
          _this.getTable(sheetNames[1])
        }
      }
      xhr.send()
    },
    getTable (sheetName) {
      console.log(sheetName)
      var worksheet = this.workbook.Sheets[sheetName]
      this.tableHead = this.excelData[2]
      // this.excelData = XLSX.utils.sheet_to_json(worksheet)

      let arr = XLSX.utils.sheet_to_json(worksheet)
      for (let i = 4; i < arr.length; i++) {
        this.excelData.push(arr[i])
      }
      console.log(this.excelData)
      console.log(this.excelData[2])
    },
    queryTable () {
      this.pageSize = 1
      this.queryDataTable()
    },
    queryDataTable () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        e_id: this.entityId,
        goods_tag: this.goodstag
      }
      querygoodsentity(params, data).then(res => {
        this.tableData = res.data.goods
        this.totalCells = res.data.cnt
      })
    },
    getTagShow (tag) {
      let name = ''
      for (let i = 0; i < this.goodstags.length; i++) {
        if (tag === this.goodstags[i].id) {
          name = this.goodstags[i].name
        }
      }
      return name
    },
    addBtn () {
      this.addEditTitle = '新建物资'
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    editBtn (row) {
      this.addEditTitle = '编辑物资'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delBtn (row) {
      this.$confirm('此操作将永久删除该物资【' + row.goods_name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletegoodsentity(data).then(res => {
          this.$notify({title: '成功', message: '成功删除', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.queryDataTable()
        })
      })
    },
    updateTable () {
      this.queryDataTable()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/goodsMaterials.vue